import React from 'react';
import BookingsTable from '../../components/BookingsTable';
import { Inspection } from '../../types/Inspection';
import { InspectionB } from '../../types/Billings';
import { InspectionMeta } from '../../types/Inspection';

export interface UserAccountBookingsProps{
    bookings?: Inspection[];
    loading?: boolean;
    outgoingBookings?: InspectionB[]
    // Outgoing bookings are paged server-side; these carry that state through.
    outgoingMeta?: InspectionMeta;
    outgoingPage?: number;        // 1-based, matching the API
    outgoingPageSize?: number;
    outgoingLoading?: boolean;
    onOutgoingPageChange?: (page: number) => void;
    onOutgoingPageSizeChange?: (pageSize: number) => void;
}

const UserAccountBookings: React.FC<UserAccountBookingsProps> = ({
    bookings, outgoingBookings, outgoingMeta, outgoingPage,
    outgoingPageSize, outgoingLoading, onOutgoingPageChange, onOutgoingPageSizeChange
}) => {

    return(
        <div>
            <BookingsTable
                inspections={bookings}
                outgoingBookings={outgoingBookings}
                outgoingMeta={outgoingMeta}
                outgoingPage={outgoingPage}
                outgoingPageSize={outgoingPageSize}
                outgoingLoading={outgoingLoading}
                onOutgoingPageChange={onOutgoingPageChange}
                onOutgoingPageSizeChange={onOutgoingPageSizeChange}
            />
        </div>
    )
}

export default UserAccountBookings;
